/**
 * Validates thrown errors for type safety. Returns an instance of Error, either from the thrown Error or from the stringified value.
 * @param value - The value to ensure is an instance of Error.
 * @returns An instance of Error.
 */
export const ensureError = (value: unknown): Error => {
  if (value instanceof Error) return value

  let stringified = '[Unable to stringify the thrown value]'
  try {
    stringified = JSON.stringify(value)
  } catch {
    // pass
  }

  const error = new Error(
    `This value was thrown as is, not through an Error: ${stringified}`
  )
  return error
}
